"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WsHousekeepingMessageMarker = exports.isHousekeepingMessage = void 0;
const constants_iso_1 = require("@wranggle/constants-iso");
Object.defineProperty(exports, "WsHousekeepingMessageMarker", { enumerable: true, get: function () { return constants_iso_1.WsHousekeepingMessageMarker; } });
const CharsToCheckInFrontAndBack = 1024;
function isHousekeepingMessage(msg) {
    if (!msg) {
        return false;
    }
    if (typeof msg === 'string') {
        if (msg.length > CharsToCheckInFrontAndBack * 2) {
            return msg.slice(0, CharsToCheckInFrontAndBack).includes(constants_iso_1.WsHousekeepingMessageMarker) ||
                msg.slice(-1 * CharsToCheckInFrontAndBack).includes(constants_iso_1.WsHousekeepingMessageMarker);
        }
        else {
            return msg.includes(constants_iso_1.WsHousekeepingMessageMarker);
        }
    }
    else if (typeof msg === 'object') {
        return !!msg[constants_iso_1.WsHousekeepingMessageMarker];
    }
    else {
        return false;
    }
}
exports.isHousekeepingMessage = isHousekeepingMessage;
//# sourceMappingURL=is-housekeeping-message.js.map